export default "__VITE_ASSET__DZYrIxaJ__"